/**
 * 近接工事・境界立会の各種Step定義
 */

/** 要否判断 判断前 */
export const P_JD_BEFORE = 0
/** 要否判断 伺い中 */
export const P_JD_CONFIRM = 1
/** 要否判断 要 */
export const P_JD_DONE = 2
/** 要否判断 不要 */
export const P_JD_NONE = 3

/** 事前協議 開始前 */
export const P_PD_BEFORE = 0
/** 事前協議 候補日入力 */
export const P_PD_INPUT = 1
/** 事前協議 日程調整中  */
export const P_PD_ADJUST = 2
/** 事前協議 日程受信 */
export const P_PD_RECV = 3
/** 事前協議 日程決定 */
export const P_PD_DECIDE = 4
/** 事前協議 日程決定 */
export const P_PD_RESULT = 5

/** 協議書 確認 */
export const P_DD_CONFIRM = 3
/** 協議書 受領 */
export const P_DD_RECEIPT = 4

/** 現地立会 開始前 */
export const P_WS_BEFORE = 0
/** 現地立会 JR日程調整中 */
export const P_WS_PRE_ADJUST = 1
/** 現地立会 JR日程回答済 */
export const P_WS_PRE_RECV = 2
/** 現地立会 日程調整中 */
export const P_WS_ADJUST = 3
/** 現地立会 日程回答済 */
export const P_WS_RECV = 4
/** 現地立会 日程決定 */
export const P_WS_DECIDE = 5
/** 現地立会 日程決定 */
export const P_WS_RESULT = 6

/** 回答 回答案送付 */
export const P_AS_SEND_DRAFT = 2
/** 回答 事前説明済 */
export const P_AS_PRE_EXPLAIN = 3
/** 回答 請書確認中 */
export const P_AS_CHECK_CONFIRMATION = 7
/** 回答 請書受領 */
export const P_AS_COMPLITE_CONFIRMATION = 8

/** 事前調査 開始前 */
export const B_PS_BEFORE = 0
/** 事前調査 結果入力済 */
export const B_PS_INPUT = 1
/** 事前調査 意見照会中 */
export const B_PS_OPINION_CONFIRM = 2
/** 事前調査 意見照会回答済 */
export const B_PS_OPINION_RECV = 3

/** 現地立会 開始前 */
export const B_WS_BEFORE = 0
/** 現地立会 JR日程調整中 */
export const B_WS_PRE_ADJUST = 1
/** 現地立会 JR日程回答済 */
export const B_WS_PRE_RECV = 2
/** 現地立会 日程調整中 */
export const B_WS_ADJUST = 3
/** 現地立会 日程回答済 */
export const B_WS_RECV = 4
/** 現地立会 日程決定 */
export const B_WS_DECIDE = 5
/** 現地立会 日程決定 */
export const B_WS_RESULT = 6

/**現地立会 確定 */
export const B_WN_CONFIRM = 0
/**現地立会 不調 */
export const B_WN_DISORDER = 1

/**
 * 要否判断
 */
export const judgeDiscussion = {
  [P_JD_BEFORE]: '判断前',
  [P_JD_CONFIRM]: '伺い中',
  [P_JD_DONE]: '要',
  [P_JD_NONE]: '不要',
} as const

/**
 * 事前協議
 */
export const priorDiscussion = {
  [P_PD_BEFORE]: '開始前',
  [P_PD_INPUT]: '候補日入力',
  [P_PD_ADJUST]: '日程調整中',
  [P_PD_RECV]: '日程受信',
  [P_PD_DECIDE]: '日程決定',
  [P_PD_RESULT]: '結果入力済',
} as const

/**
 * 協議書
 */
export const discussionDocument = {
  0: '依頼前',
  1: '依頼中',
  2: '受信',
  [P_DD_CONFIRM]: '回覧中',
  [P_DD_RECEIPT]: '受領',
} as const

/**
 * 現地立会
 */
export const witness = {
  [P_WS_BEFORE]: '開始前',
  [P_WS_PRE_ADJUST]: 'JR日程調整中',
  [P_WS_PRE_RECV]: 'JR日程回答済',
  [P_WS_ADJUST]: '日程調整中',
  [P_WS_RECV]: '日程受信',
  [P_WS_DECIDE]: '日程決定',
  [P_WS_RESULT]: '結果入力済',
  7: '意見照会中',
  8: '意見照会回答済',
} as const

/**
 * 回答
 */
export const answer = {
  0: '作成前',
  1: '伺い中',
  [P_AS_SEND_DRAFT]: '回答案送付',
  [P_AS_PRE_EXPLAIN]: '事前説明済',
  4: '回答送付',
  5: '受領連絡受信',
  6: '請書受信',
  [P_AS_CHECK_CONFIRMATION]: '請書確認中',
  [P_AS_COMPLITE_CONFIRMATION]: '請書受領',
} as const

/**
 * 覚書
 */
export const adversaria = {
  0: '依頼前',
  1: '依頼中',
  2: '受信',
  3: '覚書等送付',
} as const

/**
 * 境界立会 事前調査
 */
export const preliminarySurvey = {
  [B_PS_BEFORE]: '開始前',
  [B_PS_INPUT]: '結果入力中',
  [B_PS_OPINION_CONFIRM]: '意見照会中',
  [B_PS_OPINION_RECV]: '意見照会回答済',
}
